import moment from 'moment';

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('../../assets/fonts.js');

const formatDateTime = time => moment(time).format('DD.MM.YYYY H:m:s:SSS');

const assetTypes = {
  1: `Osakehuoneisto ${77777}%`,
  2: `Parkkipaikka/varasto/liiketila ${77777}%`,
  3: 'Yrityksen osake 1,6%',
  4: `Lomaosake ${77777}%`,
  5: 'Osuus puhelinyhtiöstä 1,6%',
  6: 'Muu arvopaperi 1,6%',
};

const transferTypes = {
  1: 'Kauppa',
  2: 'Vaihto',
  3: 'Muu',
};

const additionalSharesFromCertificatePdf = (taxStatus, currency) => {
  if (!taxStatus.certificate || !taxStatus.certificate.addShareGroup) return [];
  return [
    [
      {
        text: ' ',
        colSpan: 2,
      },
      '',
    ],
    [
      {
        text: '2. osakeryhmä:',
        bold: true,
      },
      {
        text: taxStatus.certificate.addShareGroup.shareNumbers,
      },
    ],
    [
      {
        text: 'Huoneistotunnus:',
      },
      {
        text: taxStatus.certificate.addShareGroup.residentialID,
      },
    ],
    [
      {
        text: 'Pinta-ala:',
      },
      {
        text: `${taxStatus.certificate.addShareGroup.area} m²`,
      },
    ],
    [
      {
        text: 'Kohteen tyyppi:',
      },
      {
        text: assetTypes[taxStatus.certificate.addShareGroup.assetType || 1],
      },
    ],
    [
      {
        text: 'Luovutuksen tyyppi:',
      },
      {
        text: transferTypes[taxStatus.certificate.addShareGroup.transferType || 1],
      },
    ],
    [
      {
        text: 'Kauppahinta:',
      },
      {
        text: currency(taxStatus.certificate.addShareGroup.sellingPrice),
      },
    ],
    [
      {
        text: 'Yhtiölainaosuus:',
      },
      {
        text: currency(taxStatus.certificate.addShareGroup.shareLoan),
      },
    ],
    [
      {
        text: 'Velaton kauppahinta:',
      },
      {
        text: currency(taxStatus.certificate.addShareGroup.unencumberedSellingPrice),
      },
    ],
    [
      {
        text: 'Kauppahinnan vero:',
      },
      {
        text: currency(taxStatus.certificate.addShareGroup.priceTax),
      },
    ],
    [
      {
        text: 'Yhtiölainan vero:',
      },
      {
        text: currency(taxStatus.certificate.addShareGroup.loanTax),
      },
    ],
  ];
};

// eslint-disable-next-line import/prefer-default-export
export const printTaxTradeCertificate = (taxStatus, currency, area) => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
    Icons: {
      normal: 'Icons.ttf',
    },
  };

  const content = {
    table: {
      widths: ['*', '*'],
      body: [
        [
          {
            text: 'TODISTUS SUORITETUSTA VARAINSIIRTOVEROSTA\n',
            fontSize: 15,
            color: '#333333',
            colSpan: 2,
            margin: [0, 0, 0, 20],
          },
          ' ',
        ],
        [
          {
            text: 'Taloyhtiö:',
          },
          {
            text: taxStatus.certificate.CompanyName,
          },
        ],
        [
          {
            text: 'Y-tunnus:',
          },
          {
            text: taxStatus.certificate.CompanyID,
          },
        ],
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 0, 0, 5],
          },
          ' ',
        ],
        [
          {
            text: 'Velaton kokonaiskauppahinta:',
          },
          {
            text: taxStatus.certificate.addShareGroup
              ? currency(+taxStatus.certificate.kauppahinta
                + +(taxStatus.certificate.addShareGroup?.unencumberedSellingPrice || 0))
              : currency(+taxStatus.certificate.kauppahinta),
          },
        ],
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 0, 0, 5],
          },
          ' ',
        ],
        [
          {
            text: 'Osakkeiden numerot:',
            bold: true,
          },
          {
            text: taxStatus.certificate.ShareNumbers,
          },
        ],
        [
          {
            text: 'Huoneistotunnus:',
          },
          {
            text: taxStatus.certificate.ResidentialID,
          },
        ],
        [
          {
            text: 'Pinta-ala:',
          },
          {
            text: area(taxStatus.certificate.AreaM2),
          },
        ],
        // TODO: AVAA NÄÄ
        // [
        //   {
        //     text: 'Kohteen tyyppi:',
        //   },
        //   {
        //     text: assetTypes[this.taxDetails.assetDetails.asset || 1],
        //   },
        // ],
        // [
        //   {
        //     text: 'Luovutuksen tyyppi:',
        //   },
        //   {
        //     text: transferTypes[this.taxDetails.assetDetails.transferType || 1],
        //   },
        // ],
        [
          {
            text: 'Kaupantekopäivä:',
          },
          {
            text: taxStatus.certificate.kaupantekopaiva,
          },
        ],
        [
          {
            text: 'Kauppahinta:',
          },
          {
            text: `${(taxStatus.certificate.kauppahintailmanlainaosuutta).toFixed(2).replace('.', ',')} €`,
          },
        ],
        [
          {
            text: 'Yhtiölainaosuus:',
          },
          {
            text: `${(taxStatus.certificate.lainaosuus).replace('.', ',')} €`,
          },
        ],
        [
          {
            text: 'Velaton kauppahinta:',
          },
          {
            text: `${(taxStatus.certificate.kauppahinta).replace('.', ',')} €`,
          },
        ],
        [
          {
            text: 'Kauppahinnan vero:',
          },
          {
            text: currency(taxStatus.certificate.kauppahinnanvero),
          },
        ],
        [
          {
            text: 'Yhtiölainan vero:',
          },
          {
            text: taxStatus.certificate.yhtiolainanvero ? currency(taxStatus.certificate.yhtiolainanvero) : '0 €',
          },
        ],
        [
          {
            text: 'Osin varainsiirtoverosta vapautetun ostajan maksama vero:',
          },
          {
            text: currency(taxStatus.certificate.firstTimeBuyerTax),
          },
        ],
        ...additionalSharesFromCertificatePdf(taxStatus, currency),
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 0, 0, 5],
          },
          ' ',
        ],
        [
          {
            text: 'Verot yhteensä:',
          },
          {
            text: currency(taxStatus.certificate.yhteensavero),
          },
        ],
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 0, 0, 5],
          },
          ' ',
        ],
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 5, 0, 5],
          },
          ' ',
        ],
        [
          {
            text: 'Nimi:',
          },
          {
            text: taxStatus.certificate.BuyerName,
          },
        ],
        [
          {
            text: 'Henkilötunnus / Y-tunnus:',
          },
          {
            text: taxStatus.certificate.BuyerID,
          },
        ],
        [
          {
            text: 'Omistusosuus:',
          },
          {
            text: taxStatus.share,
          },
        ],
        [
          {
            text: 'Maksettu varainsiirtovero:',
          },
          {
            text: currency(taxStatus.certificate.AmountTransferTax),
          },
        ],
        [
          {
            text: 'Vastaanottonumero:',
          },
          {
            text: taxStatus.UniqueIdentifier,
          },
        ],
        [
          {
            text: 'Vastaanottoaika:',
          },
          {
            text: formatDateTime(taxStatus.AcceptedTimestamp),
          },
        ],
        [
          {
            text: ' ',
            colSpan: 2,
            margin: [0, 10, 0, 10],
          },
          ' ',
        ],
        [
          {
            text: 'Kiinteistönvälitystoimisto:',
          },
          {
            text: taxStatus.certificate.RealEstateAgencyName,
          },
        ],
        [
          {
            text: 'Y-tunnus:',
          },
          {
            text: taxStatus.certificate.RealEstateAgencyID,
          },
        ],
        [
          {
            text: 'Osoite:',
          },
          {
            text: taxStatus.certificate.RealEstateAgencyAddress,
          },
        ],
        [
          {
            text: 'Puhelin:',
          },
          {
            text: taxStatus.certificate.RealEstateAgencyPhone,
          },
        ],
      ],
    },
    margin: [0, -10, 0, 7],
    layout: 'noBorders',
  };

  const docDefinition = {
    content,
    defaultStyle: {
      font: 'Roboto',
      fontSize: 9,
    },
    pageMargins: [50, 30, 50, 30],
    styles: {
      grayLines: {
        hLineColor: () => 'gray',
        vLineColor: () => 'gray',
      },
    },
  };
  pdfMake.createPdf(docDefinition).download(`varainsiirtovero_${taxStatus.certificate.BuyerName}.pdf`);
};
